<template>
  <div class="fill-height tutorial-container">
    <noos-tutorial />
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    extensionUrl() {
      return process.env.VUE_APP_EXTENSION_CHROME_STORE_URL;
    },
  },
};
</script>

<style scoped>
  noos-tutorial {
    margin: auto;
    margin-top: 3rem;
    max-width: 100%;
  }
  .tutorial-container {
    max-width: 100%;
    margin: auto;
    margin-top: 2rem;
  }
</style>
